import classNames from "classnames";
import React from "react";
import { Input, Button } from "reactstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { UncontrolledTooltip } from "reactstrap";
import { FiGrid } from "react-icons/fi";
import { UncontrolledPopover, PopoverBody, Badge } from "reactstrap";
export const PlansAndPricingcolumns = (editRow: number | null, editedValues: any, handleDoubleClick: any, handleChange: any, handleSubmit: any, confirmDelete: any,
    notEditable: any
) => [
        {
            name: "Plan Name",
            selector: (row: any) => row.name,
            sortable: true,
        },
        {
            name: "Apps",
            selector: (row: any) => row.selected_apps,
            sortable: true,
            cell: (row: any) => {
                const popoverId = `apps-popover-${row.id}`;
                return (
                    <div>
                        <FiGrid
                            id={popoverId}
                            size={18}
                            color="#0d6efd"
                            style={{ cursor: "pointer" }}
                        />
                        <UncontrolledPopover
                            trigger="click"
                            placement="bottom"
                            target={popoverId}
                        >
                            <PopoverBody className="d-flex flex-wrap gap-1">
                                {row.selected_apps && row.selected_apps.length > 0 ? (
                                    row.selected_apps.map((app: string, index: number) => (
                                        <Badge key={index} color="secondary">
                                            {app}
                                        </Badge>
                                    ))
                                ) : (
                                    <span>No apps selected</span>
                                )}
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            },
        },
        {
            name: "Description",
            selector: (row: any) => row.description,
            sortable: true,
        },
        {
            name: "Price",
            selector: (row: any) => row.price,
            sortable: true,
            cell: (row: any) => (
                <span className="badge bg-primary">{row.price}</span>
            )
        },
        {
            name: "Plan Validity",
            selector: (row: any) => row.days,
            sortable: true,
            cell: (row: any) => (
                <div><span className="badge bg-primary">{row.days}</span> Days</div>
            )
        },
        {
            name: "Total users",
            selector: (row: any) => row.max_users,
            sortable: true,
            cell: (row: any) => (
                <div><span className=" badge bg-light text-dark">{row.max_users}</span> Users</div>
            )

        },

        {
            name: "Actions",
            cell: (row: any) => {
                const editId = `edit-${row.id}`;
                const deleteId = `delete-${row.id}`;
                return (
                    <div className="d-flex gap-3">
                        <span id={editId}>
                            <FiEdit
                                size={18}
                                color="#0d6efd"
                                style={{ cursor: "pointer" }}
                                onClick={() => notEditable(row)}
                            />
                        </span>
                        <UncontrolledTooltip placement="top" target={editId}>
                            Edit
                        </UncontrolledTooltip>

                        <span id={deleteId}>
                            <FiTrash2
                                size={18}
                                color="#dc3545"
                                style={{ cursor: "pointer" }}
                                onClick={() => confirmDelete(row.id)}
                            />
                        </span>
                        <UncontrolledTooltip placement="top" target={deleteId}>
                            Delete
                        </UncontrolledTooltip>
                    </div>
                );
            },
        }
    ];
